import * as React from 'react';
import clx from 'classnames';
import './ProcedureStateTag.scss';
import { ProcedureState, IProcedure } from 'common/schema/Procedure';
import { Tag } from 'antd';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';
import i18next from 'i18next';
import { assertNever } from 'server/utils/typings/assertNever';

export interface ProcedureStateTagProps {
  procedure: IProcedure | undefined;
}

function procedureStateLabel(state: ProcedureState) {
  switch (state) {
    case ProcedureState.Draft:
      return i18next.t('procedures.state.draft', 'Bozza');
    case ProcedureState.Ready:
      return i18next.t('procedures.state.ready', 'Pronta');
    case ProcedureState.Published:
      return i18next.t('procedures.state.published', 'Pubblicata');
    case ProcedureState.Active:
      return i18next.t('procedures.state.active', 'Aperta');
    case ProcedureState.Evaluating:
      return i18next.t('procedures.state.evaluating', 'In Corso');
    case ProcedureState.Expired:
      return i18next.t('procedures.state.expired', 'Chiusa');
    case ProcedureState.Canceled:
      return i18next.t('procedures.state.canceled', 'Annullata');
    case ProcedureState.Suspended:
      return i18next.t('procedures.state.suspended', 'Sospesa');
    case ProcedureState.Test:
      return i18next.t('procedures.state.test', 'Collaudo');
    default:
      assertNever(state);
  }
}

export function ProcedureStateTag(props: ProcedureStateTagProps) {
  const state = ProcedureLogic.getState(props.procedure);
  return (
    <Tag className={clx('procedure-status-tag', state.toLowerCase())}>
      {procedureStateLabel(state)}
    </Tag>
  );
}
